import { Lesson, Class } from '@all-for-one/shared-types'
import { PrintOverlay } from './print-overlay'
import { DraftPdfDocument } from './pdf-draft-answer-key'

interface PrintDraftOverlayProps {
    lesson: Lesson
    className?: string
    gradeBand?: string
    subject?: string
    classData?: Class
    onDismiss: () => void
}

export const PrintDraftOverlay = (props: PrintDraftOverlayProps) => (
    <PrintOverlay
        {...props}
        PdfDocument={DraftPdfDocument}
        filenameSuffix="draft"
        headerText="Download draft questions"
        organizeStepHeading="How would you like to organize it?"
    />
)
